<template>
  <div class="layout-profile">
    <div>
      <!-- <img src="assets/layout/images/Users-Flow.png" alt="" /> -->
      <Avatar
        icon="pi pi-user"
        size="xlarge"
        style="background-color: white; color: red"
        shape="circle"
        class="p-m-2"
      ></Avatar>
    </div>
    <button class="p-link layout-profile-link" @click="onClick">
      <span class="username">{{
        state.authentication.username
      }}</span>
      <i class="pi pi-fw pi-cog"></i>
    </button>
    <transition name="layout-submenu-wrapper">
      <ul v-show="expanded">
        <!--        <li>-->
        <!--          <button class="p-link">-->
        <!--            <i class="pi pi-fw pi-user"></i><span>Account</span>-->
        <!--          </button>-->
        <!--        </li>-->
        <!-- <li>
          <button class="p-link" @click="onNotification">
            <i class="pi pi-fw pi-inbox"></i><span>การแจ้งเตือน</span>
            <span class="menuitem-badge">2</span>
          </button>
        </li> -->
        <li>
          <button class="p-link" @click="onConfirmLogout">
            <i class="pi pi-fw pi-power-off"></i><span>ออกจากระบบ</span>
          </button>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script lang="ts">
import { ref } from "vue";
import { usePlugin } from "@/plugins";

export default {
  name: "AppProfile",
  setup() {
    const { useState, onRouterReplace, onLogout, confirmation } = usePlugin();
    const expanded = ref(false);
    const onClick = (event: Event) => {
      expanded.value = !expanded.value;
      event.preventDefault();
    };
    const onConfirmLogout = () => onLogout();
    // const onConfirmLogout = () => {
    //   confirmation.require({
    //     header: "กรุณายืนยัน",
    //     message: "กรุณายืนยันเพื่อออกจากระบบ Sales Target",
    //     accept: () => onLogout(),
    //   });
    // };
    const state = useState();

    return {
      state,
      expanded,
      onClick,
      onConfirmLogout,
      // onNotification,
    };
  },
};
</script>

<style scoped></style>
